import type { AsyncBelongsTo } from '@ember-data/model';
import Model, { attr, belongsTo } from '@ember-data/model';
import type CompanyModel from 'garaje/models/company';

/**
 * Per-company HRIS sync integration record. Mirrors the Rails
 * `HrisIntegration` AR model in envoy-web (EIP-3254 / Stride 3). One row
 * per company; created when a customer connects HRIS via the HRIS plugin
 * in the app-store (slug `hris`).
 */
class HrisIntegrationModel extends Model {
  name = 'HRIS';

  @belongsTo('company', { async: true, inverse: 'hrisIntegration' })
  declare company: AsyncBelongsTo<CompanyModel>;

  @attr('string') declare provider: string;
  @attr('string') declare state: string; // pending | enabled | disabled | errored
  @attr('date') declare lastSyncAt: Date | null;
  @attr('date') declare createdAt: Date;
  @attr('date') declare updatedAt: Date;

  get isEnabled(): boolean {
    return this.state === 'enabled';
  }
  get isPending(): boolean {
    return this.state === 'pending';
  }
  get isDisabled(): boolean {
    return this.state === 'disabled';
  }
  get isErrored(): boolean {
    return this.state === 'errored';
  }
  /** Matches HrisIntegration#accepting_data? in envoy-web. */
  get acceptingData(): boolean {
    return this.isEnabled || this.isPending || this.isErrored;
  }
}

export default HrisIntegrationModel;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'hris-integration': HrisIntegrationModel;
  }
}
